import { X } from 'react-feather';
import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import { BasicMarkdown } from '@trinity/chat-components/components/Markdown/Markdown.js';
import type { BaseModalProps } from '@trinity/chat-components/hooks/useModal.js';
import { useAppSelector } from '@/store';

type Props = BaseModalProps;

export const SupportModal = ({ open, onClose }: Props) => {
  const supportContent = useAppSelector((state) => state.features.supportIcon);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog fullWidth={true} maxWidth="sm" onClose={handleClose} open={open}>
      <Header>
        <Title>Support Help</Title>
        <StyledX onClick={handleClose} />
      </Header>

      <Content>
        <BasicMarkdown>{supportContent}</BasicMarkdown>
      </Content>
    </Dialog>
  );
};

const StyledX = styled(X)({
  cursor: 'pointer',
  position: 'absolute',
  top: 15,
  right: 10,
  height: 24,
  width: 24,
});

const Header = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `15px 10px`,
  borderBottom: `1px solid ${theme.palette.gray.dark1}`,
  position: 'relative',
}));

const Title = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.bold,
  fontSize: 20,
  color: theme.palette.black.main,
}));

const Content = styled.div({
  padding: 30,
  whiteSpace: 'normal',
});
